import React, { useState } from "react";
import classes from "./Optverify.module.css";
import promix from "../../Assets/Promix.svg";
import inbox from "../../Assets/inbox.svg";
import arrow from "../../Assets/arrow.svg";
import Swal from "sweetalert2";
import { Link } from 'react-router';
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Components/API/Api";
import axios from "axios";
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';

const OnboardOTP = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", "",]);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const navigate = useNavigate();
  const [enteredOtp, setEnteredOtp] = useState("");


  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus();
      }

    }
  };

  const handleSubmit = async () => {
    const enteredOtp = otp.join(""); // Join into a single string
    if (enteredOtp.length !== 6) {
      Swal.fire("Error", "Please enter a 6-digit OTP", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/v1/otp_for_onboarding`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: localStorage.getItem("email"), // pass email if required
          otp: enteredOtp,
        }),
      });

      const data = await res.json();

      if (res.ok && (data.success || data.status)) {
        // Store token if returned in response (for registration token)
        // Check multiple possible locations for the token
        const tokenToStore = 
          data.data?.token || 
          data.data?.registration_token ||
          data.token || 
          data.registration_token ||
          null;
        
        if (tokenToStore) {
          localStorage.setItem("token", tokenToStore);
          console.log("Token stored after OTP verification");
        } else {
          // If no new token, keep existing token from signup
          const existingToken = localStorage.getItem("token");
          if (!existingToken) {
            console.warn("No token found in OTP response and no existing token in localStorage");
          } else {
            console.log("Using existing token from signup step");
          }
        }
        
        // Swal.fire("Success", data.message || "OTP verified successfully!", "success");
        navigate("/business", { state: { fromOtp: true } });
      } else {
        Swal.fire("Error", data.message || "Invalid OTP", "error");
      }

    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again!", "error");
    } finally {
      setLoading(false);
    }
  };
  // console.log("Email in storage:", localStorage.getItem("email"));
  // console.log("OTP entered:", enteredOtp);


  const handleResendOtp = async () => {
    setResendLoading(true);
    // const existingToken = localStorage.getItem("token");
    const userObj = localStorage.getItem("userObj");
    const email = userObj ? JSON.parse(userObj).email : null;
    try {
        const response = await axios.post(`${BASE_URL}/v1/resend-otp`, {
        email: email,
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      
    } finally {
      setResendLoading(false);
    }
  };



  return (
    <div className={classes.hoe}>
      <div className={classes.blink}>
        <div className={classes.put}>
          <img src={promix} alt="Promix" />
        </div>
        <div className={classes.cut}>
          <img src={inbox} alt="Inbox" />
        </div>
        <p className={classes.code}>Verify Your Account</p>
        <p className={classes.manin}>
          A 6-digit code has been sent to
          <span className={classes.pone}> {localStorage.getItem("email")}</span>
        </p>

        <div className={classes.verify}>
          {otp.map((digit, idx) => (
            <input
              key={idx}
              id={`otp-${idx}`}
              className={classes.pay_rt}
              value={digit}
              maxLength={1}
              onChange={(e) => handleChange(e, idx)}
            />
          ))}
        </div>

        <button
          className={classes.putty}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Verifying..." : "Verify"}
        </button>

        <p className={classes.orter}>Didn't receive the code? <span style={{ color: "#16A34A", cursor: "pointer" }} onClick={handleResendOtp} disabled={resendLoading}>
          {resendLoading ? (                                                            
              <>
                  <Spinner animation="border" size="sm" /> 
                  <span style={{ marginLeft: "5px" }}>Processing...</span>
              </>
              ) : (
                  "Resend OTP" 
          )}
        </span></p>
        {/* <p className={classes.crtuer}>Resend in 39s</p> */}

       <Link to="/signup"> <div className={classes.peter}>
          <img src={arrow} alt="Back" />
          <p className={classes.dart}>Back to Sign Up</p>
        </div></Link>
      </div>
    </div>
  );
};

export default OnboardOTP;
